import React, { useEffect } from "react";
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@deere/fuel-react";
import { DEFAULT_LANGUAGE_CODE, LANGUAGE_PLACEHOLDER, DESCRIPTION, LONG_DESCRIPTION } from "../../../../utils/surveyLiterals";
import { sortByLanguageList } from "../../../../utils/utils";

const TranslationsTab = ({ section, payloadData, setPayloadData, setSectionError, languageList }) => {
  const payloadLanguages = payloadData && payloadData.language ? payloadData.language.filter((hd) => hd.languageCd !== DEFAULT_LANGUAGE_CODE) : [];

  useEffect(() => {
    if (payloadData.language) {
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((sec) => sec.code === section.code);
        const newSections = [...prevState.sections];
        const newTranslations = sectionIndex > -1 ? [...newSections[sectionIndex].translations] : [];
        payloadLanguages.forEach((pl) => {
          const index = newTranslations.findIndex((nt) => nt.locale === pl.languageCd);
          if (index > -1) newTranslations[index].language = pl.text;
          else newTranslations.push({ locale: pl.languageCd, language: pl.text, text: "", longDescription: "" });
        });
        newSections[sectionIndex] = { ...newSections[sectionIndex], translations: newTranslations };
        return { ...prevState, sections: newSections };
      });
    }
  }, [payloadData.language]);

  const changeHandler = (e, langCode) => {
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((sec) => sec.code === section.code);
      const newSections = [...prevState.sections];
      const newTranslations = [...newSections[sectionIndex].translations];
      const translationIndex = newTranslations.findIndex((trn) => trn.locale === langCode);
      switch (e.target.name) {
        case "description":
          newTranslations[translationIndex].text = e.target.value;
          break;
        case "longDescription":
          newTranslations[translationIndex].longDescription = e.target.value;
          break;
      }
      newSections[sectionIndex] = { ...newSections[sectionIndex], translations: newTranslations };
      return { ...prevState, sections: newSections };
    });
    setSectionError({show: false, messsage: ""});
  };

  return (
    <Grid container mt={4} spacing={4}>
      <Table size="small">
        <TableHead sx={{ border: "none" }}>
          <TableRow>
            <TableCell>Section Name</TableCell>
            <TableCell>Section Description</TableCell>
            <TableCell>Language</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortByLanguageList(section.translations, languageList).map((tr) => (
            <TableRow key={tr.locale} sx={{ border: "none!important" }}>
              <TableCell>
                <TextField name={DESCRIPTION} required placeholder={LANGUAGE_PLACEHOLDER} onChange={(e) => changeHandler(e, tr.locale)} value={tr.text} />
              </TableCell>
              <TableCell>
                <TextField name={LONG_DESCRIPTION} required placeholder={LANGUAGE_PLACEHOLDER} onChange={(e) => changeHandler(e, tr.locale)} value={tr.longDescription} />
              </TableCell>
              <TableCell>{tr.language}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default TranslationsTab;
